import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { extractErrorMessage } from "@/types/common";

export function LoadingBox({ minHeight = 240 }: { minHeight?: number }) {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight={minHeight}>
      <CircularProgress />
    </Box>
  );
}

export function ErrorAlert({ error }: { error: unknown }) {
  return <Alert severity="error">{extractErrorMessage(error)}</Alert>;
}

export function QueryState({
  isLoading,
  error,
  children,
}: {
  isLoading: boolean;
  error: unknown;
  children: ReactNode;
}) {
  if (isLoading) return <LoadingBox />;
  if (error) return <ErrorAlert error={error} />;
  return <>{children}</>;
}
